export default __webpack_public_path__ + "static/media/0341.b36e8211.jpg";